import React from "react";
import { Box, Text } from "@chakra-ui/react";
import { useLandingTheme } from "../../LandingThemeContext";
import { useLandingCopy } from "../../LandingLanguageContext";
import { SCORE_GROUPS_IN_FRAMER_ORDER, ScoreBarChart } from "./ScoreBarChart";
import { SECTION_GAP, ThemedContainer, ThemedDisplayTitle } from "./ThemedLayout";

// The question-quality section in the original page's layout — centred two-line heading over the
// full grouped bar chart in a card, with the method footnotes — drawn in the current theme's tokens.
export function ChartQualitySection() {
  const theme = useLandingTheme();
  const qualityChartCopy = useLandingCopy().qualityChart;
  return (
    <Box as="section" mt={SECTION_GAP}>
      <ThemedContainer>
        <ThemedDisplayTitle textAlign="center" maxW="900px" mx="auto" mb={{ base: "28px", md: "40px" }} fontSize={{ base: "24px", md: "32px", lg: "34px" }}>
          {qualityChartCopy.heading}
        </ThemedDisplayTitle>

        <Box bg={theme.color.surface} border={theme.card.border} borderRadius={theme.shape.cardRadius} boxShadow={theme.card.shadow === "none" ? undefined : theme.card.shadow} p={{ base: "16px", md: "24px" }} fontFamily={theme.font.body}>
          <ScoreBarChart groups={SCORE_GROUPS_IN_FRAMER_ORDER} variant="original" />
          <Text fontSize="12px" color={theme.color.muted} mt="18px" mx="8px" lineHeight="1.5">
            {qualityChartCopy.competitorsFootnote}
          </Text>
          <Text fontSize="12px" color={theme.color.muted} mt="12px" mx="8px" lineHeight="1.5">
            {qualityChartCopy.methodFootnote}
          </Text>
        </Box>
      </ThemedContainer>
    </Box>
  );
}
